import { useState, useEffect, useCallback } from 'react';
import { axiosInstance } from '../App';

export default function useParentRegistrationStatus(user) {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStatus = useCallback(async () => {
    if (user?.role !== 'ibu_bapa') {
      setLoading(false);
      return;
    }

    try {
      const response = await axiosInstance.get('/parent/registration-status');
      setStatus(response.data);
    } catch (error) {
      console.log('Registration status check failed');
      // Default to allowing access if check fails
      setStatus({ can_access_features: true });
    } finally {
      setLoading(false);
    }
  }, [user?.role]);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  return { status, loading, refetch: fetchStatus };
}
